import React, { Component } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';
import UI from '../ui';
import { SecurityQuestionsType } from './SecurityQuestionsType.enum';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedInputTextWithLabel, WrappedDropdownWithLabel } = UI;
const { Logger, Communication, withLayoutAndModalContexts } = Utils;

class SecurityQuestions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			securityQuestions: [],
			codeWord1Question: {},
			codeWord1Answer: '',
			codeWord2Question: {},
			codeWord2Answer: '',
			codeWord1AnswerError: 0,
			codeWord2AnswerError: 0,
		};
	}

	componentDidMount() {
		this.setSecurityQuestions();
	}

	handleInputChange = e => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onInputTextBlur = e => {
		const { name } = e.target;
		const errorName = `${name}Error`;
		// eslint-disable-next-line react/destructuring-assignment
		const fieldValue = this.state[name];

		this.setState({
			[errorName]: fieldValue === '' ? -1 : 1,
		});
	};

	validateSecurityAnswers = () => {
		const {
			modalContext: { showError },
		} = this.props;
		const { codeWord1Question, codeWord2Question } = this.state;
		let validated = true;

		Object.keys(this.state).forEach(value => {
			if (value.includes('Error')) {
				// eslint-disable-next-line react/destructuring-assignment
				if (this.state[value] === 0) {
					this.setState({
						[value]: -1,
					});
					validated = false;
					// eslint-disable-next-line react/destructuring-assignment
				} else if (this.state[value] === -1) {
					validated = false;
				} else {
					validated = validated && true;
				}
			}
		});

		if (codeWord1Question === codeWord2Question) {
			showError({
				data: {
					title: 'Error',
					description: '<p>You must choose two unique questions.</p>',
					primaryButtonType: ModalButtonActionType.Ok,
					primaryButtonText: 'OK',
					handleType: 'custom',
				},
			});

			validated = false;
		}

		return validated;
	};

	// Returns an array of objects with the name and security questions for the dropdown
	setSecurityQuestions = () => {
		const questions = [];
		const {
			data: { enumCodewords },
		} = this.props;

		enumCodewords.forEach(word => {
			questions.push({ name: word, question: SecurityQuestionsType[word] });
		});

		this.setState({
			securityQuestions: questions,
		});
	};

	closeSecurityQuestionsModal = () => {
		const {
			modalId,
			modalContext: { closeModal },
		} = this.props;

		closeModal(modalId, ModalButtonActionType.Ok);
	};

	onContinueButtonClick = async () => {
		const {
			data: { callback },
			modalContext: { showError },
		} = this.props;
		const {
			codeWord1Question,
			codeWord1Answer,
			codeWord2Question,
			codeWord2Answer,
		} = this.state;

		Logger.saveActionData('Set Codewords Button Clicked');

		if (this.validateSecurityAnswers()) {
			const setCodewordsResponse = await Communication.setCodewords({
				codewordName1: codeWord1Question,
				codeword1: codeWord1Answer,
				codewordName2: codeWord2Question,
				codeword2: codeWord2Answer,
			});

			if (Communication.isSuccessful(setCodewordsResponse)) {
				callback(true);
				this.closeSecurityQuestionsModal();
			} else {
				showError({
					data: {
						title: 'Error',
						description: setCodewordsResponse.ErrorDescription,
						primaryButtonType: ModalButtonActionType.Ok,
						primaryButtonText: 'OK',
						handleType: 'custom',
					},
				});
			}
		}
	};

	render() {
		const { modalId, layoutContext } = this.props;
		const {
			securityQuestions,
			codeWord1Question,
			codeWord1Answer,
			codeWord2Question,
			codeWord2Answer,
			codeWord1AnswerError,
			codeWord2AnswerError,
		} = this.state;

		const primaryButton = {
			type: ModalButtonActionType.Ok,
			text: 'Continue',
			onClick: this.onContinueButtonClick,
			dataqa: 'security-questions-continue-button',
		};

		const { isMobile } = layoutContext;
		const mobileClassName = isMobile ? 'mobile-wrapper' : '';

		return (
			<Modal
				modalId={modalId}
				className="common-authentication auth-security-questions"
				header="Security Questions"
				primaryButton={primaryButton}
				size="small"
			>
				<div className="body">
					<p className="title">
						Answer the following security questions. The answers are case-sensitive.
					</p>
					<div className="security-questions">
						<WrappedDropdownWithLabel
							className={`dropdown ${mobileClassName}`}
							label="1st security question:"
							uiElementConfig={{
								name: 'codeWord1Question',
								value: codeWord1Question,
								options: securityQuestions,
								optionLabel: 'question',
								optionValue: 'name',
								placeholder: codeWord1Question.question || '<Please Select>',
								onChange: this.handleInputChange,
								dataqa: 'securityquestion1',
							}}
						/>
						<WrappedInputTextWithLabel
							showErrorBelow={isMobile}
							isInputInvalid={codeWord1AnswerError === -1}
							errorMessage="This field is required"
							className="inputtext"
							label="1st security answer:"
							uiElementConfig={{
								type: 'text',
								name: 'codeWord1Answer',
								value: codeWord1Answer,
								onChange: this.handleInputChange,
								onBlur: this.onInputTextBlur,
								required: true,
								dataqa: 'securityanswer1',
							}}
						/>
						<WrappedDropdownWithLabel
							className={`dropdown ${mobileClassName}`}
							label="2nd security question:"
							uiElementConfig={{
								name: 'codeWord2Question',
								value: codeWord2Question,
								options: securityQuestions,
								optionLabel: 'question',
								optionValue: 'name',
								placeholder: codeWord2Question.question || '<Please Select>',
								onChange: this.handleInputChange,
								dataqa: 'securityquestion2',
							}}
						/>
						<WrappedInputTextWithLabel
							showErrorBelow={isMobile}
							isInputInvalid={codeWord2AnswerError === -1}
							errorMessage="This field is required"
							className="inputtext"
							label="2nd security answer:"
							uiElementConfig={{
								type: 'text',
								name: 'codeWord2Answer',
								value: codeWord2Answer,
								onChange: this.handleInputChange,
								onBlur: this.onInputTextBlur,
								required: true,
								dataqa: 'securityanswer2',
							}}
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

export default withLayoutAndModalContexts(SecurityQuestions);
